export default {
  getTopReferralsData: ({ topReferralsData }) => topReferralsData,
  getCurrentRoundData: ({ currentRoundData }) => currentRoundData,
  getRewardsSettingsData: ({ rewardsSettingsData }) => rewardsSettingsData,
  getRewardsMyRatingData: ({ rewardsMyRatingData }) => rewardsMyRatingData,
};